/*
//import LinkOption from "./LinkService.vue";
import Ncf from "./NcfLinkService.vue";
import mpago from "./MagypagoLinkService.vue";
import fide from "./FidelizacionLinkService.vue";
import CustomerLink from "./CustomerLink.vue";
import TerminalLink from "./TerminalesLink.vue";
import CustomerACT from "./CustomerACT.vue";
import CustomerINA from "./CustomerINA.vue";
*/
//import hyperlinkNFC from "@/components/functionals/HyperlinkForNfcMovilReports.vue";
//import hyperlinkPP from "@/components/functionals/HyperlinkPagoProveedores.vue";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import { formatMonto } from "@/utils";
//import ColorType from "@/components/functionals/ColorType.vue";

export const PagoProveedoresDetailledColumns = [
  {
    prop: "ID",
    label: "ID",
    minWidth: 100,
    align: "center",
    sortable: true,
    fixed: true,
    formatter: (row) => row.Id
  },
  {
    prop: "fechaHora",
    label: "Fecha Hora",
    minWidth: 110,
    align: "center",
    sortable: true,
    //fixed: false,
    formatter: DatetimeFormatter
  },
  {
    prop: "Descripcion",
    label: "Descripción",
    minWidth: 170,
    sortable: true,
    formatter: (row) => row.Descripcion
    //fixed: false
    //formatter: hyperlinkNFC
  },
  {
    prop: "Monto",
    label: "Montos",
    minWidth: 100,
    align: "center",
    sortable: true,
    formatter: (row) => formatMonto(row.Monto, true)
  },
  {
    prop: "Proveedor",
    label: "Proveedor",
    minWidth: 170,
    sortable: true,
    formatter: (row) => row.Proveedor
    //fixed: false
    //formatter: hyperlinkNFC
  },
  {
    prop: "Registro Pago",
    label: "Registro Pago",
    minWidth: 170,
    sortable: true,
    formatter: (row) => row.RegistroPago
    //fixed: false
    //formatter: hyperlinkNFC
  }
];
